// extracted by mini-css-extract-plugin
export default {"wrapper":"StarDemonGame_wrapper__gclGD","sophie":"StarDemonGame_sophie__t2Z3M"};